import {Outlet, useLocation} from 'react-router-dom'
import {ContentArea} from '@/components/shared/ContentArea'
import {Send} from 'lucide-react'
import {useAuth} from '@/contexts/auth-context'
import {usePageTitle} from '@/hooks/use-page-title'
import {useI18n} from '@/i18n'
import {InlineRow} from '@/components/shared/InlineRow'
import {SidebarNav, type SidebarNavItem} from '@/components/layout/SidebarNav'
import {SidebarNavId} from '@/testids/SidebarNavTestIds'
import {routes} from '@/lib/routes'
import {permissions} from '@/lib/permissions'
import {CONCEPT_ICON} from '@/lib/concepts'
import {EmptyState} from '@/components/shared/EmptyState'
import {SectionContainer} from '@/components/shared/SectionContainer'


export function Provisioning() {
    const i18n = useI18n()
    usePageTitle(i18n.provisioning.pageTitle)
    const location = useLocation()
    const {hasPermission} = useAuth()
    const isRoot = location.pathname === `/${routes.provisioning.segment}`

    const menuItems: (SidebarNavItem & { permission: string })[] = [
        {
            id: SidebarNavId.ProvisioningDashboard,
            title: i18n.provisioning.dashboard as string,
            href: routes.provisioning.dashboard.path(),
            icon: CONCEPT_ICON.dashboard,
            description: i18n.provisioning.dashboardDesc as string,
            permission: permissions.provisioning.view,
        },
        {
            id: SidebarNavId.Tasks,
            title: i18n.provisioning.tasks as string,
            href: routes.provisioning.tasks.path(),
            icon: CONCEPT_ICON.provisioningTask,
            description: i18n.provisioning.tasksDesc as string,
            permission: permissions.provisioning.view,
        },
        {
            id: SidebarNavId.History,
            title: i18n.provisioning.history as string,
            href: routes.provisioning.history.path(),
            icon: CONCEPT_ICON.provisioningHistory,
            description: i18n.provisioning.historyDesc as string,
            permission: permissions.provisioning.view,
        },
    ]

    const visibleMenuItems = menuItems.filter(item => hasPermission(item.permission))

    return (
        <SectionContainer>
            <InlineRow align="start">
                <SidebarNav items={visibleMenuItems} aria-label={String(i18n.provisioning.pageTitle)}/>

                {/* Content Area */}
                <ContentArea>
                    {isRoot ? (
                        <EmptyState
                            variant="card"
                            icon={Send}
                            title={String(i18n.provisioning.title)}
                            description={String(i18n.provisioning.selectOption)}
                            data-testid="provisioning-welcome-card"
                        />
                    ) : (
                        <Outlet/>
                    )}
                </ContentArea>
            </InlineRow>
        </SectionContainer>
    )
}
